import { render, staticRenderFns } from "./collapseItem.vue?vue&type=template&id=24224d05&"
import script from "./collapseItem.vue?vue&type=script&lang=js&"
export * from "./collapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports